<header class="fx-row bg-grey-100 px-3 fx-justify-between pt-3 pb-1">
  <span class="tw-text-base tw-font-medium text-grey-400">
    {{ labels.dialogTitle }}
  </span>
  <button mat-dialog-close>
    <mat-icon class="text-grey-400">close</mat-icon>
  </button>
</header>
<mat-dialog-content class="p-3 pb-0">
  <div class="fx-center fx-gap-1">
    <div class="fx-center flex-50 fx-gap-2 p-2 bg-accent-300 radius-4 fx-justify-between px-3 text-grey-400">
      <p class="text-base">
        {{ labels.successDescription }}
      </p>
      <p class="text-semibold">
        {{ plantPorted.length }}
      </p>
    </div>
    <div
      *ngIf="plantFailed.length > 0"
      class="fx-center flex-50 fx-gap-2 p-2 bg-yellow-300 radius-4 fx-justify-between px-3 text-grey-400">
      <p class="text-base">
        {{ labels.failedDescription }}
      </p>
      <p class="text-semibold">
        {{ plantFailed.length }}
      </p>
    </div>
  </div>

  <mat-divider class="mt-2"></mat-divider>

  <section class="pos-rel">
    <div
      #scrollableContent
      appScrollWatcher
      class="mt-2 fx-align-baseline fx-center fx-gap-2 fx-justify-between max-h-75 overflow-y-scroll">
      <ng-container
        *ngIf="{
          isOverflowingBottom: isOverflowingBottom(scrollableContent),
          isScrolledToBottom: isScrolledToBottom(scrollableContent)
        } as container">
        <div
          *ngIf="container.isOverflowingBottom"
          class="pos-abs inset-b-0 inset-r-1 z-index-1 radius-4 p-1 bg-white bg-opacity-70 mr-n-2">
          <button
            mat-button
            class="s-8 bg-accent min-w-10"
            (click)="scrollableContent.scrollBy(0, 150); $event.stopPropagation()">
            <mat-icon class="s-4 min-s-4 m-auto text-white rotate-90">chevron_right</mat-icon>
          </button>
        </div>
        <div
          *ngIf="container.isScrolledToBottom"
          class="pos-abs inset-t-0 inset-r-1 z-index-1 radius-4 p-1 bg-white bg-opacity-70 mr-n-2">
          <button
            mat-button
            class="s-8 bg-accent min-w-10"
            (click)="scrollableContent.scrollBy(0, -150); $event.stopPropagation()">
            <mat-icon class="s-4 min-s-4 m-auto text-white rotate-270">chevron_right</mat-icon>
          </button>
        </div>

        <div *ngIf="plantPorted.length" class="fx-col fx-gap-1 fx-g-1">
          <div
            *ngFor="let plant of plantPorted"
            class="p-4 bg-accent-100 border-grey-100 border-1 radius-4">
            <p>{{ plant }}</p>
          </div>
        </div>
        <div *ngIf="plantFailed.length" class="fx-col fx-gap-1 fx-g-1">
          <div
            *ngFor="let plant of plantFailed"
            class="p-4 bg-yellow-100 border-grey-100 border-1 radius-4">
            <p>{{ plant }}</p>
          </div>
        </div>
      </ng-container>
    </div>
  </section>

  <section
    *ngIf="plantFailed.length > 0"
    class="border-1 mt-2 fx-center fx-gap-3 p-1 radius-4 border-grey-100 w-full">
    <mat-icon class="text-yellow-300">
      info
    </mat-icon>
    <customer-title-content
      class="fx-g-1"
      [content]="labels.portingFailureDescription">
    </customer-title-content>
  </section>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <customer-simple-button
    mat-dialog-close
    [label]="labels.closeButton">
  </customer-simple-button>
</mat-dialog-actions>
